import React from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'

export type ShareLoanActionsIconType = 'loading' | 'delete'

type ShareLoanActionsIconProps = {
	contentType: ShareLoanActionsIconType
}

const ShareLoanActionsIcon = ({
	contentType,
}: ShareLoanActionsIconProps) => {
	if (contentType === 'loading') return <CircularProgress size={20} />

	return <DeleteIcon />
}

export default ShareLoanActionsIcon
